export default __webpack_public_path__ + "static/media/FACE_ICON.13f437c2.svg";